<div class="container pt-3" *ngIf="!pruefblattScreen">
  <app-header (antragReset)="onReset()"
              (antragLoaded)="onLoad($event)"
  ></app-header>


  <app-visum-erfassung
    [visumErfassung]="modelUpdate$ | async"
    (validitiesChange)="updateValidities($event)"
    (formChange)="onFormChange($event)"
  ></app-visum-erfassung>

  <!--type must match styles import in angular.json  -->
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>

  <app-button-bar (antragReset)="onReset()"
                  (antragSaved)="onSave()"
                  (antragCompleted)="onComplete()"
                  [disableButtons]="disableButtons"
                  [validities]="validities"
  ></app-button-bar>

  <app-footer></app-footer>
</div>
<div class="container pt-3 pb-3" *ngIf="pruefblattScreen">
  <app-pruefblatt (printPruefblatt)="onPrintPruefblatt()"></app-pruefblatt>
</div>

<ng-template #antragOeffnenFehler>
  <div class="modal-header">
    <h4 class="modal-title" i18n>Fehler beim Öffnen des Antrages</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold" *ngFor="let entry of antragOeffnenFehlermeldungen | entries ">{{ entry.value }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="onCancel()" class="btn btn-danger" style="width: 170px"><span i18n>Abbrechen</span></button>
  </div>
</ng-template>


<ng-template #mekFehler let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Fehler beim Speichern</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="validationErrors.validationConstraintViolations; then validationConstraintViolations else errorMessage"></div>
  <div class="modal-footer">
    <button type="button" (click)="c('cancel')" class="btn btn-danger" style="width: 170px"><span i18n>Abbrechen</span></button>
  </div>
</ng-template>

<ng-template #errorMessage>
  <div class="modal-body">
    <p style="font-weight: bold">{{ validationErrors.message }}</p>
  </div>
</ng-template>

<ng-template #validationConstraintViolations *ngIf="validationErrors">
  <div class="modal-body">
    <p style="font-weight: bold" *ngFor="let entry of validationErrors.validationConstraintViolations | entries ">{{ entry.value }}</p>
  </div>
</ng-template>


<ng-template #validationErrorsDialog let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Validierungsfehler</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="validationErrors">
    <p style="font-weight: bold" *ngFor="let entry of validationErrors.validationConstraintViolations | entries ">{{ entry.value }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="c('close')" class="btn btn-danger" style="width: 170px"><span i18n>Schließen</span></button>
  </div>
</ng-template>

<ng-template #unknownErrorDialog let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" translate>Fehler</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c('cancel')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="font-weight: bold" translate>Es ist ein Fehler aufgetreten.</p>
  </div>
  <div class="modal-footer">
    <button type="button" (click)="c('close')" class="btn btn-danger" style="width: 170px"><span translate>Schließen</span></button>
  </div>
</ng-template>

<ng-template #antragViewer let-c="close">
  <div class="modal-header">
    <h4 class="modal-title" i18n>Ihre Daten wurden geprüft.</h4>
    <button type="button" class="modal-close" aria-label="Close" (click)="c({ result: 'cancel' })">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <p>
      <span i18n>Sie können Ihren Visumantrag jetzt als PDF-Datei herunterladen. Hinweis: Bitte beachten Sie, dass dieser Ausdruck lediglich der Antragsvorbereitung dient, zur Antragstellung also explizit weitere Schritte erfolgen müssen.</span>
    </p>
    <a *ngIf="antragViewerUrl"
       [href]="antragViewerUrl"
       target="_blank"
       rel="noopener noreferrer"
       class="btn btn-primary"
       (click)="onPdfClick()"
    >
      <span i18n>PDF herunterladen</span>
    </a>
  </div>
</ng-template>
